import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartiesCmp_Person_Fragment = graphql(`
  fragment ThirdPartiesCmp_Person_Fragment on Person {
    _id
    kind
    civilityId
    firstName
    lastName
    statusId
  }
`);

export type ThirdPartiesCmp_Person = ResultOf<
  typeof ThirdPartiesCmp_Person_Fragment
>;
